import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Neumna vsebina",
  "description": "",
  "published": "2007-01-03T00:00:00.000Z",
  "redirect_from": ["/blog/neumna-vsebina/swizec/340"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ko te dni gledamo po straneh kot je Youtube, opazimo shrljivo pomanjkanje zanimivih vsebin. V osnovi so bile narejene za deljenje videov oz. bi si tako vsaj lahko mislili, vsi pa bi se strinjalil, da so to glasbeni videi, odlomki iz tu in tam in seveda, je marsikaj takega. Vse prevec pa je neumnih stvari, ki jih ljudje posnamejo sami in dajo na internet preprosto ker lahko.`}</p>
    <p>{`Vsi poznamo nevarnosti gledanja domacih videov in tega nihce ne mara, edino hujsi so umetniski videi mladih studentvo, ki vztrajajo na vecnih poskusih umetniskega ustvarjanja, na koncu pa ustvarijo negledljivo sranje, ki konec koncev ni niti kaj prevec globoko.`}</p>
    <p>{`Potem pa so tu se dobre stvari. Ena takih je naprimer video cloveka, ki v desetih korakih ponazori `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=EDHIyHtv0E8"
      }}>{`odpiranje kozarca`}</a>{`, ali pa prijetna razprava o `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=JdxkVQy7QLM"
      }}>{`Pachelbelovem Canon v D`}</a>{`. To so dobre stvari, ki so celo zelo legalne za biti na internetu ... zakaj torej ni veliko `}<em parentName="p">{`veliko`}</em>{` vec takih?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      